"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClientRect = void 0;
const react_1 = __importStar(require("react"));
const useClientRect = () => {
    const element = react_1.useRef(null);
    const [rect, setRect] = react_1.useState(null);
    const handleResize = react_1.useCallback(() => {
        if (element.current) {
            setRect(element.current.getBoundingClientRect());
        }
    }, []);
    react_1.useEffect(() => {
        if (!rect) {
            return;
        }
        /*
         * we have to wait here because element size could be changed after render
         * and there is no other way to handle this situation
         */
        const to = setTimeout(() => {
            var _a;
            const newRect = (_a = element.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (newRect &&
                rect &&
                (newRect.width !== rect.width ||
                    newRect.height !== rect.height ||
                    newRect.x !== rect.x ||
                    newRect.y !== rect.y)) {
                setRect(newRect);
            }
        }, 0);
        return () => clearTimeout(to);
    });
    const ref = react_1.default.useCallback((node) => {
        if (node !== null) {
            window.addEventListener('resize', handleResize);
            setRect(node.getBoundingClientRect());
        }
        else {
            window.removeEventListener('resize', handleResize);
            setRect(null);
        }
        element.current = node;
    }, [handleResize]);
    return [rect, ref, element.current];
};
exports.useClientRect = useClientRect;
//# sourceMappingURL=use-client-rect.js.map